import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'activeIcon', 'inactiveIcon'];
  static values = { active: Boolean };

  toggle(event) {
    if (event.type === 'keydown') event.preventDefault();
    this.activeValue = !this.activeValue;
  }

  activeValueChanged() {
    this.inputTarget.value = this.activeValue ? '1' : '0';
    this.element.setAttribute('aria-checked', this.activeValue);
    this.activeIconTarget.classList.toggle('hidden', !this.activeValue);
    this.inactiveIconTarget.classList.toggle('hidden', this.activeValue);
  }
}
